import type React from 'react';
import type { PropsWithChildren } from 'react';

import type { ButtonProps } from '@xing-com/button';
import { Button } from '@xing-com/button';

import { useTracking } from '../../hooks/use-tracking';
type BaseButtonProps = ButtonProps & {
  trackingAttributes?: Record<string, string>;
};

export const BaseButton: React.FC<PropsWithChildren<BaseButtonProps>> = ({
  trackingAttributes,
  onClick,
  ...props
}) => {
  const { generateHandleTracking } = useTracking();
  const handleTracking = generateHandleTracking({
    onClick: onClick ? (onClick as $TSFixMe) : undefined,
    to: props.to,
    href: props.href,
    target: props.target,
    trackingAttributes,
  });

  const handleClick = trackingAttributes
    ? (handleTracking as $TSFixMe)
    : onClick;

  return <Button {...{ ...props, onClick: handleClick }} />;
};

export default BaseButton;
